import dayjs from 'dayjs';
import { HevoEntityMeta, RawHevoEntityMeta } from '../interfaces/entity-meta';

export function EntityMetaFactory(data: RawHevoEntityMeta): HevoEntityMeta {
  return {
    createdAt: dayjs(data.created_ts).format('MMM DD, YYYY hh:mm A'),
    createdBy: data.created_by?.display_name ?? '-',
    createById: data.created_by?.id,
    updatedAt: dayjs(data.updated_ts).format('MMM DD, YYYY hh:mm A'),
    updatedBy: data.updated_by?.display_name ?? '-',
    updatedByID: data.updated_by?.id
  };
}
